/**
 * @generated SignedSource<<b8085d887930b950cb556de2ee453287>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectsLoader_financialsCompanyCurrency$data = {
  readonly financialNumbers: {
    readonly billablePlannedTimeAndExpenses: number | null;
    readonly actualRevenue: number | null;
    readonly remainingRevenue: number | null;
    readonly forecastRevenue: number | null;
    readonly recognitionOpenRevenue: number | null;
    readonly recognitionForecastRevenue: number | null;
    readonly recognitionLockedRevenue: number | null;
    readonly plannedCost: number | null;
    readonly actualCost: number | null;
    readonly forecastCost: number | null;
    readonly remainingCost: number | null;
    readonly plannedProfit: number | null;
    readonly forecastProfit: number | null;
    readonly invoiced: number | null;
    readonly paid: number | null;
  } | null;
  readonly " $fragmentType": "ProjectsLoader_financialsCompanyCurrency";
};
export type ProjectsLoader_financialsCompanyCurrency$key = {
  readonly " $data"?: ProjectsLoader_financialsCompanyCurrency$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectsLoader_financialsCompanyCurrency">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectsLoader_financialsCompanyCurrency",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billablePlannedTimeAndExpenses",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionOpenRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionForecastRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionLockedRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plannedCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plannedProfit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastProfit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiced",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "3a3a12ed48d895d0d4894611c1bca787";

export default node;
